import { html, LitElement, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getDiagramVisual } from "../../data/visuals";

import styles from "./viz-diagram.css";

import type { DiagramVisualData } from "../../types.d";
import type { PropertyValues } from "lit";

@customElement("bp-viz-diagram")
export class VizDiagram extends LitElement {
  static styles = styles;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: DiagramVisualData;

  render() {
    if (!this.data) return nothing;

    const { src, alt, caption } = this.data;

    return html`
      <figure>
        <img src=${src} alt=${alt} title=${alt} />

        ${caption && html`<bp-caption>${unsafeHTML(caption)}</bp-caption>`}
      </figure>
    `;
  }

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getDiagramVisual(this.arcId)
      .then(({ data }) => {
        this.data = data;
      })
      .catch(() => undefined);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-viz-diagram": VizDiagram;
  }
}
